import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import LongStay from "@/pages/LongStay";
import LongStayThankYou from "@/pages/LongStayThankYou";
import Properties from "@/pages/Properties";
import PropertyDetail from "@/pages/PropertyDetail";
import WhyChooseUs from "@/pages/WhyChooseUs";
import Contact from "@/pages/Contact";
import BookingSuccess from "@/pages/BookingSuccess";
import BookingCheckout from "@/pages/BookingCheckout";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AuthCallback from "@/pages/AuthCallback";
import AdminRoute from "@/components/AdminRoute";
import AmbientAudio from "@/components/AmbientAudio";
import SEOHead from "@/components/SEOHead";
import ScrollToTop from "@/components/ScrollToTop";
import { AuthProvider } from "@/lib/auth";
import { SiteContentProvider } from "@/lib/cms";
import { useAnalytics } from "@/lib/analytics";
import { useWhatsAppTracking } from "@/lib/whatsappTracking";

function AppRouter() {
  const location = useLocation();
  useAnalytics();
  useWhatsAppTracking();
  // Global scroll restoration — reset scroll on every route change.
  // Detect OAuth callback synchronously during render
  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  // Admin pages bypass the public Layout (no public navbar/footer/whatsapp)
  if (location.pathname.startsWith("/admin")) {
    return (
      <Routes>
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminRoute><AdminDashboard /></AdminRoute>} />
      </Routes>
    );
  }

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/long-stay" element={<LongStay />} />
        <Route path="/long-stay/thank-you" element={<LongStayThankYou />} />
        <Route path="/services" element={<Navigate to="/long-stay" replace />} />
        <Route path="/properties" element={<Properties />} />
        <Route path="/properties/:id" element={<PropertyDetail />} />
        <Route path="/properties/:id/reserve" element={<BookingCheckout />} />
        <Route path="/why-choose-us" element={<WhyChooseUs />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/booking/success" element={<BookingSuccess />} />
      </Routes>
      <AmbientAudio />
    </Layout>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <SiteContentProvider>
            <SEOHead />
            <ScrollToTop />
            <AppRouter />
            <Toaster
              position="top-right"
              theme="light"
              richColors
              toastOptions={{
                style: {
                  background: "#F4EFE3",
                  border: "1px solid #DED4BD",
                  color: "#14110C",
                  fontFamily: "Manrope, sans-serif",
                },
              }}
            />
          </SiteContentProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
